module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-24GIU-25-023cbc863f18a9ccba043bda0df64377.jpg";